module.exports = __webpack_public_path__ + "static/entrance-bba2793f0e71efceee07b709d9071e1f.jpg";